import KonamiCode from 'vue3-konami-code';

export default defineNuxtPlugin((nuxtApp) => {
  let isDebug: boolean;
  const route = useRoute();
  const userDebug = useNomadStorage('user', 'common', 'system');
  nuxtApp.vueApp.use(KonamiCode, {
    onKonamiCodeEntered: function () {
      if (route.path.includes('/mon-compte')) {
        userDebug.value = 'testMember';
      }
    },
  });
  return {
    provide: {
      debug: isDebug,
    },
  };
});
